@if (!actions || actions.length === 0) {
  <button
    [ngClass]="buttonClass ? buttonClass : null"
    mat-flat-button
    [type]="type"
    [color]="color"
    class="bg-primary-600 text-white disabled:bg-gray-200 hover:bg-primary-500"
    [disabled]="state.loading || disabled"
    (click)="onClick.emit()"
    [matTooltip]="state.matTooltip"
    >
    @if (!state.loading) {
      <span> {{ state.buttonLabel }} </span>
    } @else {
      <mat-progress-spinner
        [diameter]="24"
        [mode]="'indeterminate'"
      ></mat-progress-spinner>
    }
  </button>
} @else {
  <div slot="action" class="inline-flex items-stretch rounded-md shadow-sm">
    <button
      [ngClass]="buttonClass ? buttonClass : null"
      mat-flat-button
      [type]="type"
      [color]="color"
      class="bg-primary-600 text-white disabled:bg-gray-200 hover:bg-primary-500 rounded-r-none"
      [disabled]="state.loading || disabled"
      (click)="onClick.emit()"
      [matTooltip]="state.matTooltip"
      >
      @if (!state.loading) {
        <span>
          {{ state.buttonLabel }}
        </span>
      } @else {
        <mat-progress-spinner
          [diameter]="24"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
      }
    </button>
    <button
      mat-raised-button
      [color]="color"
      class="rounded-l-none min-w-10 px-2 relative after:absolute after:top-0 after:bottom-0 after:left-0 after:w-px after:bg-white/70 dark:after:bg-white/30"
      [matMenuTriggerFor]="additionalActionsMenu"
      [disabled]="state.loading || disabled"
      >
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
  </div>
  <mat-menu #additionalActionsMenu="matMenu">
    @for (action of actions; track action) {
      <button
        mat-menu-item
        (click)="actioned.emit(action)"
        [disabled]="state.loading || disabled"
        >
        <span>{{ action.label }}</span>
      </button>
    }
  </mat-menu>
}

